import { Injectable, inject } from '@angular/core';
import { SystemConfigCacheService } from '../services/system-config-cache.service';
import { resolveLmsDocumentPath } from '../utils/lms-document-path.util';

const IMAGE_PATH_MODULE = 'IMAGE_PATH';

@Injectable({
  providedIn: 'root',
})
export class LmsDocumentPathHelper {
  private readonly systemConfigCache = inject(SystemConfigCacheService);

  resolve(documentPath?: string | null, fileName?: string | null): string | null {
    const imageRoot = this.systemConfigCache.getByModule(IMAGE_PATH_MODULE)?.values ?? null;
    return resolveLmsDocumentPath(documentPath, fileName, imageRoot);
  }
}
